import { PlayerMetricHeuristic } from '../../jscaip/AI/PlayerMetricHeuristic';
import { PlayerNumberTable } from '../../jscaip/PlayerNumberTable';
import { ConspirateursState } from './ConspirateursState';
export class ConspirateursHeuristic extends PlayerMetricHeuristic {
    getMetrics(node, _config) {
        const state = node.gameState;
        const scores = PlayerNumberTable.of([0, 0], [0, 0]);
        const shelterCountIndex = 0;
        const distanceCountIndex = 1;
        for (const coordAndContent of state.getPlayerCoordsAndContent()) {
            const coord = coordAndContent.coord;
            const player = coordAndContent.content;
            if (state.isShelter(coord)) {
                scores.add(player, shelterCountIndex, 1);
            }
            else {
                let minEmptyShelterDistance = state.getWidth() + state.getHeight();
                // start as the maximum distance possible
                for (const shelter of ConspirateursState.ALL_SHELTERS) {
                    if (state.getPieceAt(shelter).isNone()) {
                        const distance = coord.getOrthogonalDistance(shelter);
                        minEmptyShelterDistance = Math.min(minEmptyShelterDistance, distance);
                    }
                }
                scores.add(player, distanceCountIndex, -minEmptyShelterDistance);
            }
        }
        return scores;
    }
}
